import { getToken, cookieName } from 'auth/user/AuthUtils.bs';
import { magicUserAgentHeader } from 'config/Config.bs';
import Cookies from 'js-cookie';
import { decryptUserCookie } from 'utils/authUtils';

const getUrl = (subRoute: string) => `${process.env.NEXT_PUBLIC_PREZZEE_SERVER_URL}${subRoute}`;
const getHeaders = (withAuth = false, withMagicUserAgentOnServerOnly = false) => {
  let headers = {
    'content-type': 'application/json',
    accept: 'application/json',
  };
  const fingerprint = Cookies.get('fingerprint-pz');

  if (fingerprint) headers['x-device-fingerprint'] = fingerprint;
  if (withAuth) {
    const userCookie = Cookies.get(cookieName);
    const decryptedUser = userCookie ? decryptUserCookie(userCookie) : undefined;
    const isMasq = decryptedUser?.masquerade;
    const tokenType = isMasq ? 'Masq' : 'Bearer';

    headers['Authorization'] = `${tokenType} ${getToken()}`;
  }
  if (withMagicUserAgentOnServerOnly) headers['User-Agent'] = magicUserAgentHeader;

  return headers;
};

export const get = async (
  url: string,
  options?: {
    withAuth?: boolean;
    withMagicUserAgentOnServerOnly?: boolean;
  }
) => {
  const defaultOptions = {
    withAuth: false,
    withMagicUserAgentOnServerOnly: false,
  };
  const options_ = { ...defaultOptions, ...options };

  try {
    const res = await fetch(getUrl(url), {
      method: 'GET',
      headers: getHeaders(options_.withAuth, options_.withMagicUserAgentOnServerOnly),
    });
    return await res.json();
  } catch (e) {
    throw e;
  }
};

export const getFile = async (url: string, withAuth = false) => {
  try {
    const res = await fetch(getUrl(url), {
      method: 'GET',
      headers: getHeaders(withAuth),
    });
    let blob = await res.blob();

    return blob;
  } catch (e) {
    throw e;
  }
};

const update = async (method: 'POST' | 'PATCH' | 'DELETE', url: string, data: any, withAuth = false) => {
  try {
    const res = await fetch(getUrl(url), {
      method,
      headers: getHeaders(withAuth),
      mode: 'cors',
      credentials: 'same-origin',
      body: data ? JSON.stringify(data) : undefined,
    });
    if (res.ok) {
      try {
        return await res.json();
      } catch {
        return null;
      }
    }
    return null;
  } catch (e) {
    throw e;
  }
};

export const post = (url: string, data: any, withAuth = false) => {
  return update('POST', url, data, withAuth);
};

export const patch = (url: string, data: any, withAuth = false) => {
  return update('PATCH', url, data, withAuth);
};

export const remove = (url: string, data: any, withAuth = false) => {
  return update('DELETE', url, data, withAuth);
};
